import { render } from "./App.vue?vue&type=template&id=53d73f7c&scoped=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=53d73f7c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-53d73f7c"

export default script